import { render } from "./LegacyFabricVersions.vue?vue&type=template&id=253afd81&ts=true"
import script from "./LegacyFabricVersions.vue?vue&type=script&lang=ts"
export * from "./LegacyFabricVersions.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__